import Footer from '@/components/layout/Footer';
import Header from '@/components/layout/Header';
import {
	AppShell
} from '@mantine/core';
import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { SessionContext } from '@/context/SessionContext';

const Layout: React.FC = () => {
	const session = useContext(SessionContext);
	if (session === undefined) {
		throw new Error("Layout must be a child of sessionContext.");
	}

	return (
		<AppShell
			header={{ height: 40 }}
			footer={{ height: 32 }}
		>
			<AppShell.Header>
				<Header />
			</AppShell.Header>

			<AppShell.Main bg="blue" h="100dvh">
				<Outlet />
			</AppShell.Main>

			<AppShell.Footer>
				<Footer />
			</AppShell.Footer>
		</AppShell>
	);
};

export default Layout;